"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreShootsBanner = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../../");
const image_png_1 = __importDefault(require("./image.png"));
const MoreShootsBanner_module_css_1 = __importDefault(require("./MoreShootsBanner.module.css"));
const MoreShootsBanner = props => {
    const component = __1.useIntlScope('@lemonone/components/MoreShootsBanner:');
    return (react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.wrapper },
        react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.left },
            react_1.default.createElement("img", { src: image_png_1.default, alt: "Location" })),
        react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.right },
            react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.heading }, component('wantToSeeMore')),
            react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.text }, component('seeOtherShoots', {
                here: (children) => react_1.default.createElement("span", { className: MoreShootsBanner_module_css_1.default.link }, children)
            })))));
};
exports.MoreShootsBanner = MoreShootsBanner;
//# sourceMappingURL=MoreShootsBanner.js.map